import { render, staticRenderFns } from "./BasicButton.vue?vue&type=template&id=0df752e0&scoped=true&"
import script from "./BasicButton.vue?vue&type=script&lang=js&"
export * from "./BasicButton.vue?vue&type=script&lang=js&"
import style0 from "./BasicButton.vue?vue&type=style&index=0&id=0df752e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df752e0",
  null
  
)

export default component.exports